import { createSlice } from '@reduxjs/toolkit';

import { ProductSelectDataInitialState } from './initialState';

const initialState = ProductSelectDataInitialState;

const ProductSelectDataSlice = createSlice({
  name: 'ProductSelectData',
  initialState,
  reducers: {
    setRawCategories: (state, action) => {
      state.rawCategories = action.payload;
    },
    setRawSuppliers: (state, action) => {
      state.rawSuppliers = action.payload;
    },
    setHasFetchedCategories: (state, action) => {
      state.hasFetchedCategories = action.payload;
    },
    setHasFetchedSuppliers: (state, action) => {
      state.hasFetchedSuppliers = action.payload;
    },
    setProductsCategoryOptions: (state, action) => {
      state.searchCategory.productsCategoryOptions = action.payload;
    },
    setIsCatOptionsLoading: (state, action) => {
      state.searchCategory.isCatOptionsLoading = action.payload;
    },
    setSupplierOptions: (state, action) => {
      state.searchSuppliers.supplierOptions = action.payload;
    },
    setIsSupplierOptionsLoading: (state, action) => {
      state.searchSuppliers.isSupplierOptionsLoading = action.payload;
    },
  },
});

export const {
  setRawCategories,
  setRawSuppliers,
  setHasFetchedCategories,
  setHasFetchedSuppliers,
  setProductsCategoryOptions,
  setIsCatOptionsLoading,
  setSupplierOptions,
  setIsSupplierOptionsLoading,
} = ProductSelectDataSlice.actions;

export default ProductSelectDataSlice.reducer;
